import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-havana-block-modal',
  templateUrl: './havana-block-modal.component.html',
  styleUrl: './havana-block-modal.component.scss',
  standalone: false,
})
export class HavanaBlockModalComponent {
  constructor(public modal: NgbActiveModal) {}
}
